<template>
    <div>
        <BackButton/>

        <div class="inner-content full">
            <ClientFiche :client="client" v-if="client != null" />
        </div>

        <Loading v-if="loading" />

    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import ClientFiche from "@/components/dna/ClientFiche.vue";
import Loading from "@/components/app/Loading.vue";
import {apiStore} from "@/stores/api";

export default {
    name : "ClientDetail",
    components : {
        BackButton,
        ClientFiche,
        Loading
    },
    data() {
        return {
            client: null,
            loading: true
        };
    },

    async created() {
        try {
            this.ergosleep_id = this.$route.params.ergosleep_id;
            const result = await apiStore().getErgosleepUserById(this.ergosleep_id);
            if (result.client !== null) {
                this.client = result.client;
            }
        } catch (error) {
            console.error("getErgosleepUserById error:", error);
        } finally {
            this.loading = false;
        }

        apiStore().forceAppointmentCompleted(this.ergosleep_id);
    }
};
</script>
